import React from 'react';
import {useIntl} from 'react-intl';
import cn from 'classnames';

import {IColorDescriptionProps} from './IColorDescription';
import messages from './messages';

const ColorDescription = ({classNames, product}: IColorDescriptionProps) => {
	const intl = useIntl();
	const colorDescription = product.getColorDescription() || product.getVariationValue('color');

	if (!colorDescription) {
		return null;
	}

	return (
		<div className={cn('color-description', classNames)}>
			<div className="color-description__value">
				{intl.formatMessage(messages.color, {color: colorDescription})}
			</div>
		</div>
	);
};

export default ColorDescription;
